/** Dot-path on wrapped supplemental payload where the row array lives (matches typical pipeline `{ data: [...] }`). */
export const DEFAULT_SUPPLEMENTAL_ITEMS_PATH = 'data'

/** Status value treated as "complete" for strikethrough / success styling. */
export const COMPLETED_STATUS = 'Completed'
